<template>
  <div>
    <vm-table
        ref="vmTable"
        height="68vh"
        :filter.sync="filter"
        module="basic"
        url="applications/todo/my">
      <template slot="adSearch">
        <div class="vm-search">
          <el-radio-group v-model="filter.isread" style="margin-top: -20px" @change="getList(1)">
            <el-radio label="">全部</el-radio>
            <el-radio label="1">已读</el-radio>
            <el-radio label="0">未读</el-radio>
          </el-radio-group>
          <vm-search label="">
            <el-input v-model.trim="filter.filter" placeholder="请输入关键字查询" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="billNO" label="单号">
        <template slot-scope="scope">
          <a @click="gotoApprove(scope.row)">{{scope.row.billNO}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="customerName" label="客户名称" align="center"/>
      <el-table-column prop="descrpt" label="节点名称" align="center"/>
      <el-table-column prop="creatorName" label="制单人" align="center"/>
      <el-table-column prop="createdTime" label="上节点处理时间" align="center"/>
      <el-table-column prop="submitDate" label="创建时间" align="center"/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "DeliveryAddressApprove",
    components: {VmTable, VmSearch},
    data() {
      return {
        filter: {
          billType: 37,
          isread: "",
          filter: "",
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      gotoApprove(row) {
        this.$router.push({
          path: "/approval",
          query: {
            billType: 37,
            billId: row.billID,
            sequId: row.sequID,
            $tabName: "审批_" + row.billNO,
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
